/**
 * State logic for WebGL context loss in the 3D viewer. `epoch` is the React key of the Canvas:
 * bumping it re-mounts the canvas and so creates a fresh context.
 * events: 'lost' (webglcontextlost), 'restored' (webglcontextrestored), 'retry' (user click).
 */
export const initialContextState = { lost: false, epoch: 0 };

export function contextReducer(state, event) {
  switch (event) {
    case 'lost': return state.lost ? state : { ...state, lost: true };
    case 'restored':
    case 'retry': return { lost: false, epoch: state.epoch + 1 };
    default: return state;
  }
}

/** Wire the loss/restore events of a canvas; returns the cleanup. The loss is preventDefault'ed so the browser may restore. */
export function watchContext(canvas, dispatch) {
  if (!canvas?.addEventListener) return () => {};
  const onLost = (e) => { e.preventDefault(); dispatch('lost'); };
  const onRestored = () => dispatch('restored');
  canvas.addEventListener('webglcontextlost', onLost, false);
  canvas.addEventListener('webglcontextrestored', onRestored, false);
  return () => {
    canvas.removeEventListener('webglcontextlost', onLost, false);
    canvas.removeEventListener('webglcontextrestored', onRestored, false);
  };
}
